import { Helmet } from "react-helmet";
import FaqHomeOne from "../components/common/faq/faq-home-one";
import FeatureSectionTwo from "../components/common/feature/feature-section-two";
import ClientSliderOne from "../components/common/sliders/client/client-slider-one";
import TestimonialSliderOne from "../components/common/sliders/testimonial/testimonial-slider-one";
import VideoSectionTwo from "../components/common/video/video-section-two";
import ContentWithPhotoSection from "../components/home/content-with-photo-section";
import ContentWithPhotoSectionTwo from "../components/home/content-with-photo-section-two";
import CtaHomeOne from "../components/home/cta-home-one";
import HeroSection from "../components/home/hero-section";

function Home() {
	return (
		<>
			<Helmet>
				<title>fugu - index -01</title>
			</Helmet>
			<HeroSection />
			<ClientSliderOne />
			<FeatureSectionTwo />
			<ContentWithPhotoSection />
			<VideoSectionTwo />
			<ContentWithPhotoSectionTwo />
			<TestimonialSliderOne />
			<FaqHomeOne />
			<CtaHomeOne />
		</>
	);
}

export default Home;
